<span class="ui-status-chip tw:inline-flex tw:items-center tw:justify-center tw:text-app-text tw:leading-app-normal tw:whitespace-nowrap"
  [class.ui-status-chip-compact]="compact()"
  [class.ui-status-chip-tone-neutral]="tone() === 'neutral'"
  [class.ui-status-chip-tone-success]="tone() === 'success'"
  [class.ui-status-chip-tone-warning]="tone() === 'warning'"
  [class.ui-status-chip-tone-danger]="tone() === 'danger'">
  {{ label() }}
</span>
